import { render, staticRenderFns } from "./Kid.vue?vue&type=template&id=82aa7a7a&scoped=true&"
import script from "./Kid.vue?vue&type=script&lang=js&"
export * from "./Kid.vue?vue&type=script&lang=js&"
import style0 from "./Kid.vue?vue&type=style&index=0&id=82aa7a7a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82aa7a7a",
  null
  
)

export default component.exports